import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getToolById } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';

interface ToolsDetailsNCFileProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
  ncFileId: number | null;
}

const ToolsDetailsNCFileComponent: FC<ToolsDetailsNCFileProps> = ({ getToolById, updateHeaderConfig, getNCFileById, ncFileData, ncFileId }) => {
  const title = useTitle();

  const { ncFileDataLoading } = useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
        <NCFileListOrSingleItem
          ncFileData={[ncFileData.data]}
          ncFileDataLoading={!ncFileData.wasLoaded}
          ncFileId={ncFileId}
          ncFileDataLoadingForList={ncFileDataLoading}
        />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFile = connect(({ details: { ncFileData, ncFileId } }) => ({ ncFileData, ncFileId }), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFileComponent);

export { ToolsDetailsNCFile };
